import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormFieldBaseComponent } from '../form-field-base.component';
import { Scope, StarRatingViewKind } from '@sb/library/base';

@Component({
    selector: 'lib-input-star-rating',
    templateUrl: './form-field-star-rating.component.html',
    styleUrls: ['./form-field-star-rating.component.scss']
})
export class FormFieldStarRatingComponent extends FormFieldBaseComponent<number | null, FormControl<number | null>> implements OnInit {
    @Input() loading: boolean = false;

    // form control is out of 100
    // view control is the count of stars

    @Input() starCount: number = 5; // number of stars its out of
    @Input() numReviews?: number;

    private _starLevels: number[] = [];
    private _starHovered: number | null = null;

    constructor() {
        super();
        this.viewControl = new FormControl<number | null>(null);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this._starLevels = Array.from({ length: this.starCount }, (_, i) => i + 1);
    }

    override writeValue(value: number | null) {
        this.viewControl.setValue(this.CalculateStars(value));
    }


    StarClicked(rating: number): void {
        // user clicks on the same star, it resets the rating
        const newRating = (this.viewControl.value == rating) ? null : rating;
        this.SetFormControl(newRating);
        this.viewControl.setValue(newRating);
    }

    StarHovered(rating: number): void {
        this._starHovered = rating;
    }

    MouseLeave(): void {
        this._starHovered = null;
    }

    SetFormControl(stars: number | null): void {
        if (stars) {
            const starsAsAPercent = (stars / this.starCount) * 100;
            this.formControl.setValue(starsAsAPercent, { emitModelToViewChange: false });
            this.SetFormControlValue(starsAsAPercent);
        } else {
            this.formControl.setValue(null, { emitModelToViewChange: false });
            this.SetFormControlValue(null);
        }
    }

    override setDisabledState(state: boolean): void {
        if (state) {
            this.viewControl.disable();
            this._starHovered = null;
        } else {
            this.viewControl.enable();
        }
    }

    private CalculateStars(ratingValue: number | null): number {
        if (ratingValue) {
            return (ratingValue / 100) * this.starCount;
        }
        return 0;
    }

    get starLevels(): number[] {
        return this._starLevels;
    }

    get currentRating(): number | null {
        return this.viewControl.value ? Math.floor(this.viewControl.value) : null;
    }

    get starHovered(): number | null {
        return this._starHovered;
    }
}
